import {
  lookupDurationBilling,
  type DurationBillingItem,
} from '@airship-platform/proposal-financing-feature/utils';
import { useMemo } from 'react';
import { useMembershipData } from './OfflineMembershipDataProvider';

export const useDurationBilling = (
  pricebookId: string
): DurationBillingItem[] => {
  const { durationBillingIndex } = useMembershipData();

  return useMemo(
    () =>
      pricebookId
        ? lookupDurationBilling(durationBillingIndex, pricebookId)
        : [],
    [durationBillingIndex, pricebookId]
  );
};
